import { FunctionComponent } from 'react';
import { Delta } from './interfaces';
import { LabelAndValue } from 'components/common/LabelAndValue/LabelAndValue';
import { DeltaValue } from './DeltaValue';

export const DeltaRow: FunctionComponent<{
	label: string;
	delta?: Delta<any>;
}> = ({ label, delta }) =>
	delta ? (
		<LabelAndValue
			label={label}
			value={<DeltaValue from={delta.from} to={delta.to} />}
		/>
	) : null;
